import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { roleToString, UserRole } from "utils/role";
type InviteeItemProps = {
  email: string;
  role: UserRole;
  state?: "wait" | "expried";
  onHandleResend?: () => void;
  onHandleDelete?: () => void;
};

const InviteeItem = (props: InviteeItemProps) => {
  const { email, role, state, onHandleResend, onHandleDelete } = props;
  return (
    <ItemContainer>
      <ProfileContainer>
        <UI.Typography
          style={{ minWidth: "200px", maxWidth: "240px" }}
          type="label01"
          fontStyle="regular"
          color={state === "wait" ? "var(--alias-color-label-normal)" : "var(--alias-color-label-disabled)"}
        >
          {email}
        </UI.Typography>
        <UI.Typography
          style={{
            minWidth: "160px",
            maxWidth: "200px",
          }}
          type="label01"
          fontStyle="regular"
          color={state === "wait" ? "var(--alias-color-label-normal)" : "var(--alias-color-label-disabled)"}
        >
          {roleToString(role)}
        </UI.Typography>
      </ProfileContainer>
      <InviteContainer>
        <div style={{ minWidth: "120px", maxWidth: "160px", display: "flex" }}>
          {state === "wait" ? (
            <UI.Tag label="수락 대기중" color="orange" />
          ) : (
            <UI.Tag label="초대 링크 만료" color="gray" />
          )}
        </div>
        <div style={{ minWidth: "120px", maxWidth: "160px" }}>
          <UI.Button size="small" title="재전송하기" primary={false} onClick={onHandleResend} />
        </div>
        <div style={{ minWidth: "120px", maxWidth: "160px" }}>
          <UI.Button type="outlined" size="small" title="취소하기" primary={false} onClick={onHandleDelete} />
        </div>
      </InviteContainer>
    </ItemContainer>
  );
};

export default InviteeItem;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 24px;
  gap: 32px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

const ProfileContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex: 1;
`;

const InviteContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;
